export default "__VITE_ASSET__DMiqoT1M__"